import React, { useState, useEffect } from "react";
import "./style/notification.css";
import * as moment from "moment";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as propertyActions from "../../../../actionCreators/Property";
import { doGet, doPost } from "../../../../utils/request";
import { useHistory } from "react-router-dom";
import { Spin, message } from "antd";
import { Typography, Pagination } from "antd";

const notificationTiTypes = {
  proofSubmitted: "Proof Submitted",
  newChallan: "Request for new challan",
};

const NotificationListing = ({
  notifications,
  getNotifications,
  decrementNotificationCount,
  user,
}) => {
  const history = useHistory();
  const [data, setData] = React.useState([]);
  const [isInspector, setIsInspector] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [pagination, setPagination] = React.useState({});
  const [pageSize, setPageSize] = useState(10);
  useEffect(() => {
    getNotifications({ page: 0, pageSize: 20 });
  }, []);
  useEffect(() => {
    if (notifications.data) {
      setData(notifications.data);
      setLoading(notifications.loading);
      setPagination(notifications.pagination);
    }
  }, [notifications]);
  React.useEffect(() => {
    if (user) {
      setIsInspector(
        user?.currentUser?.data?.user_roles.findIndex((e) => e.role_id == 1) >=
          0
      );
    }
  }, [user]);
  const onNotificationClick = async (data) => {
    const status = await doPost("/notification/status", { id: data?.id });
    if (!data.read) {
      decrementNotificationCount();
    }
    if (isInspector) {
      if (data?.notification?.title === notificationTiTypes["proofSubmitted"]) {
        history.push(`/tax-collection/view/${data?.challan_id}`);
        return;
      }
      if (data?.notification?.title === notificationTiTypes["newChallan"]) {
        history.push(`/tax-collection/detail-view/${data?.property_id}`);
        return;
      }
      message.warning("Please view this on field app");
      return;
    }
    if (data?.property_id !== null) {
      history.push("/properties/view/" + data?.property_id);
    } else {
      history.push("/detected/all");
    }
  };
  const handleTableChange = (page, pageSize) => {
    setPageSize(pageSize);
    getNotifications({ page: page - 1, pageSize: pageSize });
  };
  return (
    <div>
      <Typography className="heading">Notifications</Typography>
      <div className="notificationBody">
        {loading ? (
          <div
            style={{
              position: "fixed",
              top: "55%",
              left: "57%",
            }}
          >
            <Spin />
          </div>
        ) : data.length === 0 ? (
          <div
            style={{
              width: "100%",
              height: "70vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            No notifications to show.
          </div>
        ) : (
          <>
            {data.map((data, index) => (
              <div
                className="notificationContainer"
                key={index}
                onClick={() => onNotificationClick(data)}
              >
                <div
                  className={`notificationTitle ${
                    data.read ? "" : "unreadNotification"
                  }`}
                >
                  {data?.read === false ? (
                    <span className="iconContainer">•</span>
                  ) : (
                    ""
                  )}
                  {data?.notification?.body}
                </div>
                <div
                  className={`notificationTime ${
                    data.read ? "" : "unreadNotification"
                  }`}
                >
                  {moment(data.created_at).fromNow()}
                </div>
              </div>
            ))}

            <div className="pagination">
              <Pagination
                current={pagination.currentPage + 1}
                total={pagination.count}
                defaultPageSize={20}
                pageSize={pageSize}
                pageSizeOptions={["10", "20", "30"]}
                onChange={handleTableChange}
                showSizeChanger={true}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};
const mapStateToProps = ({ user, property: { notifications } }) => ({
  notifications,
  user,
});

const mapDispatchToProps = (dispatch) => ({
  getNotifications: bindActionCreators(
    propertyActions.getNotifications,
    dispatch
  ),
  decrementNotificationCount: bindActionCreators(
    propertyActions.decrementNotificationCount,
    dispatch
  ),
});

NotificationListing.propTypes = {
  notifications: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  getNotifications: PropTypes.func.isRequired,
  decrementNotificationCount: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NotificationListing);
